export default __webpack_public_path__ + "static/media/notificationsIcon.7633c7ec.svg";